import { render } from "./businessSummaryDetail.vue?vue&type=template&id=6aff78ad&scoped=true&ts=true"
import script from "./businessSummaryDetail.vue?vue&type=script&lang=ts"
export * from "./businessSummaryDetail.vue?vue&type=script&lang=ts"

import "./businessSummaryDetail.vue?vue&type=style&index=0&id=6aff78ad&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aff78ad"]])

export default __exports__